import { Form } from 'react-bootstrap'

function Textareafield({ label, name, value, error, onChange, placeholder, required, reference }) {

  const handleChange = (event) => {
    const { name, value } = event.target
    onChange({ name, value })
  }

  return (
    <div className="mb-3">
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          ref={reference}
          className={error ? 'is-invalid' : ''}
          as="textarea"
          placeholder={placeholder}
          value={value}
          name={name}
          onChange={handleChange}
          required={required}
        />
      </Form.Group>
      {error && <small className="text-danger">{error}</small>}
    </div>
  )
}

export default Textareafield;
